import { buildProps } from '@ll-plus/utils'
import { ExtractPropTypes } from 'vue'
import type Signature from './signature.vue'

export const signatureProps = buildProps({
  width: {
    type: Number,
    default: 800,
  },
  height: {
    type: Number,
    default: 400,
  },
  placeholder: {
    type: String,
    default: '请在此区域签名',
  },
  lineWidth: {
    type: Number,
    default: 2,
  },
  strokeStyle: {
    type: String,
    default: '#000000',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hiddenBorder: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export type SignatureProps = ExtractPropTypes<typeof signatureProps>

// instance
export type SignatureInstance = InstanceType<typeof Signature>
